import Tooltip from "../../../common/StyledToolTip";
function DropYardMarker(props) {
  return (
    <Tooltip
      title={
        props.data ? (
          <div>
            {props.data.name}
            <br />
            {props.data.address}
          </div>
        ) : (
          ""
        )
      }
    >
      <svg
        width={props.size || "40"}
        height={props.size || "40"}
        viewBox="0 0 51 51"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="25.8306"
          y="0.707107"
          width="34.4619"
          height="34.4619"
          rx="1.5"
          transform="rotate(45 25.8306 0.707107)"
          fill="#ABAEB2"
        />
        <path
          d="M25.4875 26.1333C25.4875 27.259 25.2802 28.2 24.8655 28.9565C24.4508 29.7085 23.8492 30.2759 23.0608 30.6587C22.2769 31.0369 21.3245 31.2261 20.2034 31.2261H17.4622V21.2319H20.511C21.5318 21.2319 22.4137 21.4188 23.1565 21.7925C23.8993 22.1616 24.4736 22.7108 24.8791 23.4399C25.2847 24.1646 25.4875 25.0623 25.4875 26.1333ZM24.0178 26.1743C24.0178 25.3175 23.8788 24.6112 23.6008 24.0552C23.3228 23.4992 22.915 23.0868 22.3772 22.8179C21.8394 22.5444 21.1809 22.4077 20.4016 22.4077H18.8635V30.0366H20.1555C21.4452 30.0366 22.4114 29.7131 23.054 29.0659C23.6965 28.4188 24.0178 27.4549 24.0178 26.1743ZM30.3684 26.0171L32.884 21.2319H34.3879L31.0657 27.3433V31.2261H29.6643V27.4048L26.3352 21.2319H27.8665L30.3684 26.0171Z"
          fill="black"
        />
        <rect
          x="25.8306"
          y="0.707107"
          width="34.4619"
          height="34.4619"
          rx="1.5"
          transform="rotate(45 25.8306 0.707107)"
          stroke="black"
        />
      </svg>
    </Tooltip>
  );
}

export default React.memo(DropYardMarker);
